import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const clientStatusList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/client-status/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const clientStatusAdd = (params) => {
  return _baseClient.post('/client-status/save', { body: params }).then((response) => {
    return response;
  });
};

export const clientStatusDelete = (params) => {
  return _baseClient.get('/client-status/delete', params);
};

export const clientStatusDetail = (params) => {
  return _baseClient.get('/client-status/get', params);
};

export const clientStatusUpdateStatus = (params) => {
  return _baseClient.get('/client-status/update-status', params);
};
